export class SwpppSite {
    id!: string
    job!: string
    name!: string
    latitude!: number
    longitude!: number
    address?: string | null
    acreage?: number | null
    disturbedAcreage?: number | null
    ms4?: string | null
    isActive!: boolean
    publicToken!: string
    nwsStationId?: string | null
    lastPrecip24hInches?: number | null
    forecast48hPrecipChance?: number | null
    weatherCheckedOn?: string | null
    archived!: boolean
    createdOn!: string
}

export class SwpppSitePerson {
    id!: string
    siteId!: string
    userId?: string | null
    name?: string | null
    email?: string | null
    phone?: string | null
    company?: string | null
    role!: string
    isPublicContact!: boolean
    receivesReports!: boolean
    reportPackage?: string | null
    requiresActionSignoff!: boolean
    archived!: boolean
}

export class SwpppInspectionAssignment {
    id!: string
    siteId!: string
    formId!: string
    triggerType!: string
    frequency?: string | null
    precipThresholdInches?: number | null
    startDate!: string
    includeWeatherHistory!: boolean
    allowSimultaneous!: boolean
    isActive!: boolean
}

export class SwpppAssignmentUser {
    id!: string
    assignmentId!: string
    userId!: string
}

export class SwpppReminder {
    id!: string
    assignmentId!: string
    type!: string
    offsetValue!: number
    offsetUnit!: string
}

export class SwpppInspectionDue {
    id!: string
    assignmentId!: string
    siteId!: string
    weatherEventId?: string | null
    windowStart!: string
    windowEnd!: string
    status!: string
    inspectionId?: string | null
}

export class SwpppForm {
    id!: string
    name!: string
    disclaimerText?: string | null
    isActive!: boolean
}

export class SwpppQuestion {
    id!: string
    formId!: string
    groupKey!: string
    groupTitle?: string | null
    text!: string
    sortOrder!: number
    answerType!: string
    options?: string | null
    allowOtherText!: boolean
    prefillSource?: string | null
}

export class SwpppInspection {
    id!: string
    siteId!: string
    dueId?: string | null
    formId!: string
    inspectorUserId?: string | null
    inspectionDateTime!: string
    finishedOn?: string | null
    comments?: string | null
    siteMapDocumentId?: string | null
    status!: string
    signedName?: string | null
    signerTitle?: string | null
    signatureConfirmed!: boolean
    signedOn?: string | null
    sentOn?: string | null
}

export class SwpppAnswer {
    id!: string
    inspectionId!: string
    questionId!: string
    value?: string | null
    otherText?: string | null
}

export class SwpppActionItem {
    id!: string
    inspectionId?: string | null
    siteId!: string
    description!: string
    location?: string | null
    assignedPersonId?: string | null
    dueDate?: string | null
    status!: string
    completedOn?: string | null
    completedByName?: string | null
    completionSignature?: string | null
    verifiedOn?: string | null
}

export class SwpppDocument {
    id!: string
    siteId!: string
    docType!: string
    title!: string
    permitNumber?: string | null
    permitType?: string | null
    permitDescription?: string | null
    effectiveDate?: string | null
    expirationDate?: string | null
    renewedOn?: string | null
    reminderDaysBefore!: number
}

export class SwpppDocumentFile {
    id!: string
    swpppDocumentId!: string
    extension!: string
    fileName!: string
}

export class SwpppNote {
    id!: string
    siteId!: string
    text!: string
    createdOn!: string
}

export class SwpppWeatherEvent {
    id!: string
    siteId!: string
    eventStart!: string
    eventEnd?: string | null
    precipInches!: number
    stationId?: string | null
}

export class SwpppDailyPrecip {
    id!: string
    siteId!: string
    date!: string
    precipInches!: number
}

export class SwpppInspectionImage {
    id!: string
    swpppInspectionId!: string
    extension!: string
    fileName!: string
    caption?: string | null
}

export interface SwpppDashboardRow {
    kind: string
    title: string
    siteId: string
    detail: string
}

export interface SwpppDashboard {
    dueInspections: number
    missedInspections: number
    openActionItems: number
    lateActionItems: number
    recentWeatherEvents: number
    permitsExpiring: number
    permitsExpired: number
    sitesMissingPermit: number
    sitesMissingPlan: number
    sitesMissingMap: number
    rows: SwpppDashboardRow[]
}

export interface SwpppSiteBundle {
    site: SwpppSite
    people: SwpppSitePerson[]
    assignments: SwpppInspectionAssignment[]
    assignmentUsers: SwpppAssignmentUser[]
    reminders: SwpppReminder[]
    dues: SwpppInspectionDue[]
    documents: SwpppDocument[]
    documentFiles: SwpppDocumentFile[]
    inspections: SwpppInspection[]
    actionItems: SwpppActionItem[]
    weatherEvents: SwpppWeatherEvent[]
    dailyPrecip: SwpppDailyPrecip[]
    notes: SwpppNote[]
}

export interface SwpppInspectionDetail {
    inspection: SwpppInspection
    site: SwpppSite
    questions: SwpppQuestion[]
    answers: SwpppAnswer[]
    disclaimerText?: string | null
    permits: SwpppDocument[]
    siteMaps: SwpppDocument[]
    openActionItems: SwpppActionItem[]
    images: SwpppInspectionImage[]
    recentPrecip: SwpppDailyPrecip[]
    recipients: SwpppSitePerson[]
    lastInspectionBy?: string | null
    lastInspectionOn?: string | null
    lastInspectionId?: string | null
    suggestedTitle?: string | null
}

export interface SwpppPublicSite {
    companyName: string
    siteName: string
    job: string
    address?: string | null
    latitude: number
    longitude: number
    contacts: SwpppSitePerson[]
}

export interface SwpppPublicReport {
    package: string
    siteName: string
    inspection?: SwpppInspection | null
    questions: SwpppQuestion[]
    answers: SwpppAnswer[]
    actionItems: SwpppActionItem[]
    images: SwpppInspectionImage[]
}
